
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { documentStore, singularityStore, uiStore } from "@/store/store";
import { findNode } from "@/lib/tree/tree";
import lodash from "lodash";
import SingularityPanelHeader from "@/components/Singularity/PanelHeader/SingularityPanelHeader.vue";
import { MediaInputValue } from "@/types/media";

@Component({
  components: {
    TextInput,
    SingularityPanelHeader
  }
})
export default class TextEditor extends Vue {
  get uiStoreActiveElementId() {
    return uiStore.activeElementId;
  }

  @Watch("uiStoreActiveElementId")
  closePanelIfElementIdChanges() {
    if (this.textEditorPanelState?.elementId !== this.uiStoreActiveElementId) {
      singularityStore.setTextEditorPanelState(null);
    }
  }

  get textEditorPanelState() {
    return singularityStore.textEditorPanelState;
  }

  get textInputValue() {
    if (!this.textEditorPanelState) return null;

    const node = findNode(
      documentStore.document.tree,
      this.textEditorPanelState.elementId
    );

    if (!node) return null;

    const result = lodash.get(
      node.data.properties,
      this.textEditorPanelState.contentEditablePropertyPath
    );

    if (!result) return null;

    return result;
  }

  updateTextInputValue(value: MediaInputValue) {
    if (!this.textEditorPanelState?.elementId) return;

    documentStore.unthrottledPropertyChanged({
      elementId: this.textEditorPanelState.elementId,
      path: this.textEditorPanelState.contentEditablePropertyPath,
      value: value,
      meta: {
        snapshotLabel: "Text Editor Input Update"
      }
    });
  }
}
